// A component token's value in px, for the few places a behaviour library takes a number rather than a
// style (React Aria's pop-over offset). Read from the page at render, so the token set stays the one
// source and the token panel's changes reach it.
export function tokenPx(name: string, el?: Element | null): number {
  if (typeof window === 'undefined') return 0;
  const target = el ?? document.documentElement;
  const v = Number.parseFloat(getComputedStyle(target).getPropertyValue(name));
  return Number.isFinite(v) ? v : 0;
}
